// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/split_supply_contract_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { VoltageClass } from "./occto_master_model_pb";
import { file_bffuser_v1_occto_master_model } from "./occto_master_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Decimal } from "../../google/type/decimal_pb";
import { file_google_type_decimal } from "../../google/type/decimal_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/split_supply_contract_model.proto.
 */
export const file_bffuser_v1_split_supply_contract_model: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bffuser_v1_occto_master_model, file_buf_validate_validate, file_google_protobuf_timestamp, file_google_type_date, file_google_type_decimal]);

/**
 * SplitSupplyBusiness mirrors internalapi.v1.SplitSupplyBusiness 1:1.
 *
 * @generated from message bffuser.v1.SplitSupplyBusiness
 */
export type SplitSupplyBusiness = Message<"bffuser.v1.SplitSupplyBusiness"> & {
  /**
   * UUID of the business master record.
   *
   * @generated from field: string business_master_id = 1;
   */
  businessMasterId: string;

  /**
   * @generated from field: string business_code = 2;
   */
  businessCode: string;

  /**
   * @generated from field: string business_name = 3;
   */
  businessName: string;
};

/**
 * Describes the message bffuser.v1.SplitSupplyBusiness.
 * Use `create(SplitSupplyBusinessSchema)` to create a new message.
 */
export const SplitSupplyBusinessSchema: GenMessage<SplitSupplyBusiness> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_contract_model, 0);

/**
 * SplitSupplyBasePatternInput mirrors internalapi.v1.SplitSupplyBasePatternInput
 * 1:1. The domain checks the contents; the wire also rejects an order below 1.
 *
 * @generated from message bffuser.v1.SplitSupplyBasePatternInput
 */
export type SplitSupplyBasePatternInput = Message<"bffuser.v1.SplitSupplyBasePatternInput"> & {
  /**
   * @generated from field: int32 pattern_order = 1;
   */
  patternOrder: number;

  /**
   * @generated from field: google.type.Date valid_from = 2;
   */
  validFrom?: Date;

  /**
   * @generated from field: optional google.type.Date valid_to = 3;
   */
  validTo?: Date;

  /**
   * @generated from field: repeated bffuser.v1.SplitSupplyDayType day_types = 4;
   */
  dayTypes: SplitSupplyDayType[];

  /**
   * @generated from field: repeated int32 months = 5;
   */
  months: number[];

  /**
   * @generated from field: optional int32 slot_from = 6;
   */
  slotFrom?: number;

  /**
   * @generated from field: optional int32 slot_to = 7;
   */
  slotTo?: number;

  /**
   * @generated from field: repeated int64 slot_values = 8;
   */
  slotValues: bigint[];
};

/**
 * Describes the message bffuser.v1.SplitSupplyBasePatternInput.
 * Use `create(SplitSupplyBasePatternInputSchema)` to create a new message.
 */
export const SplitSupplyBasePatternInputSchema: GenMessage<SplitSupplyBasePatternInput> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_contract_model, 1);

/**
 * SplitSupplyBasePattern mirrors internalapi.v1.SplitSupplyBasePattern 1:1.
 *
 * @generated from message bffuser.v1.SplitSupplyBasePattern
 */
export type SplitSupplyBasePattern = Message<"bffuser.v1.SplitSupplyBasePattern"> & {
  /**
   * @generated from field: int32 pattern_order = 1;
   */
  patternOrder: number;

  /**
   * @generated from field: google.type.Date valid_from = 2;
   */
  validFrom?: Date;

  /**
   * @generated from field: optional google.type.Date valid_to = 3;
   */
  validTo?: Date;

  /**
   * @generated from field: repeated bffuser.v1.SplitSupplyDayType day_types = 4;
   */
  dayTypes: SplitSupplyDayType[];

  /**
   * @generated from field: repeated int32 months = 5;
   */
  months: number[];

  /**
   * @generated from field: optional int32 slot_from = 6;
   */
  slotFrom?: number;

  /**
   * @generated from field: optional int32 slot_to = 7;
   */
  slotTo?: number;

  /**
   * @generated from field: repeated int64 slot_values = 8;
   */
  slotValues: bigint[];
};

/**
 * Describes the message bffuser.v1.SplitSupplyBasePattern.
 * Use `create(SplitSupplyBasePatternSchema)` to create a new message.
 */
export const SplitSupplyBasePatternSchema: GenMessage<SplitSupplyBasePattern> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_contract_model, 2);

/**
 * SplitSupplyContractListItem mirrors internalapi.v1.SplitSupplyContractListItem 1:1.
 *
 * @generated from message bffuser.v1.SplitSupplyContractListItem
 */
export type SplitSupplyContractListItem = Message<"bffuser.v1.SplitSupplyContractListItem"> & {
  /**
   * @generated from field: optional bfftypes.v1.AreaCode area_code = 1;
   */
  areaCode?: AreaCode;

  /**
   * @generated from field: string supply_point_specific_number = 2;
   */
  supplyPointSpecificNumber: string;

  /**
   * @generated from field: optional string customer_name = 3;
   */
  customerName?: string;

  /**
   * @generated from field: bffuser.v1.SplitSupplyForm supply_form = 4;
   */
  supplyForm: SplitSupplyForm;

  /**
   * @generated from field: optional int32 own_slot_from = 5;
   */
  ownSlotFrom?: number;

  /**
   * @generated from field: optional int32 own_slot_to = 6;
   */
  ownSlotTo?: number;

  /**
   * @generated from field: bffuser.v1.SplitSupplyBusiness load_following = 7;
   */
  loadFollowing?: SplitSupplyBusiness;

  /**
   * @generated from field: bffuser.v1.SplitSupplyBusiness base = 8;
   */
  base?: SplitSupplyBusiness;

  /**
   * @generated from field: bffuser.v1.SplitSupplySelfRole self_role = 9;
   */
  selfRole: SplitSupplySelfRole;

  /**
   * @generated from field: optional string updated_by = 10;
   */
  updatedBy?: string;

  /**
   * Also the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 11;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.SplitSupplyContractListItem.
 * Use `create(SplitSupplyContractListItemSchema)` to create a new message.
 */
export const SplitSupplyContractListItemSchema: GenMessage<SplitSupplyContractListItem> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_contract_model, 3);

/**
 * SplitSupplyContract mirrors internalapi.v1.SplitSupplyContract 1:1.
 *
 * @generated from message bffuser.v1.SplitSupplyContract
 */
export type SplitSupplyContract = Message<"bffuser.v1.SplitSupplyContract"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;

  /**
   * @generated from field: optional bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode?: AreaCode;

  /**
   * @generated from field: optional string customer_name = 3;
   */
  customerName?: string;

  /**
   * @generated from field: bffuser.v1.SplitSupplyForm supply_form = 4;
   */
  supplyForm: SplitSupplyForm;

  /**
   * @generated from field: bffuser.v1.SplitSupplyBusiness load_following = 5;
   */
  loadFollowing?: SplitSupplyBusiness;

  /**
   * @generated from field: optional string load_following_contract_id = 6;
   */
  loadFollowingContractId?: string;

  /**
   * @generated from field: bffuser.v1.SplitSupplyBusiness base = 7;
   */
  base?: SplitSupplyBusiness;

  /**
   * @generated from field: optional string base_contract_id = 8;
   */
  baseContractId?: string;

  /**
   * @generated from field: optional int32 base_priority = 9;
   */
  basePriority?: number;

  /**
   * @generated from field: optional int32 own_slot_from = 10;
   */
  ownSlotFrom?: number;

  /**
   * @generated from field: optional int32 own_slot_to = 11;
   */
  ownSlotTo?: number;

  /**
   * @generated from field: string note = 12;
   */
  note: string;

  /**
   * @generated from field: bffuser.v1.SplitSupplySelfRole self_role = 13;
   */
  selfRole: SplitSupplySelfRole;

  /**
   * @generated from field: repeated bffuser.v1.SplitSupplyBasePattern base_patterns = 14;
   */
  basePatterns: SplitSupplyBasePattern[];

  /**
   * @generated from field: optional string created_by = 15;
   */
  createdBy?: string;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 16;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional string updated_by = 17;
   */
  updatedBy?: string;

  /**
   * Also the optimistic-lock baseline.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 18;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: bffuser.v1.SplitSupplyNoticeBy notice_by = 19;
   */
  noticeBy: SplitSupplyNoticeBy;

  /**
   * @generated from field: optional google.type.Decimal base_contract_kw = 20;
   */
  baseContractKw?: Decimal;
};

/**
 * Describes the message bffuser.v1.SplitSupplyContract.
 * Use `create(SplitSupplyContractSchema)` to create a new message.
 */
export const SplitSupplyContractSchema: GenMessage<SplitSupplyContract> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_contract_model, 4);

/**
 * SplitSupplyPointOption mirrors internalapi.v1.SplitSupplyPointOption 1:1.
 *
 * @generated from message bffuser.v1.SplitSupplyPointOption
 */
export type SplitSupplyPointOption = Message<"bffuser.v1.SplitSupplyPointOption"> & {
  /**
   * @generated from field: string supply_point_specific_number = 1;
   */
  supplyPointSpecificNumber: string;

  /**
   * @generated from field: string customer_name = 2;
   */
  customerName: string;

  /**
   * @generated from field: bfftypes.v1.AreaCode area_code = 3;
   */
  areaCode: AreaCode;

  /**
   * @generated from field: bffuser.v1.VoltageClass voltage_class = 4;
   */
  voltageClass: VoltageClass;
};

/**
 * Describes the message bffuser.v1.SplitSupplyPointOption.
 * Use `create(SplitSupplyPointOptionSchema)` to create a new message.
 */
export const SplitSupplyPointOptionSchema: GenMessage<SplitSupplyPointOption> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_split_supply_contract_model, 5);

/**
 * SplitSupplyForm mirrors internalapi.v1.SplitSupplyForm 1:1.
 *
 * @generated from enum bffuser.v1.SplitSupplyForm
 */
export enum SplitSupplyForm {
  /**
   * @generated from enum value: SPLIT_SUPPLY_FORM_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 固定型.
   *
   * @generated from enum value: SPLIT_SUPPLY_FORM_FIXED = 1;
   */
  FIXED = 1,

  /**
   * 時間分割型.
   *
   * @generated from enum value: SPLIT_SUPPLY_FORM_TIME_SPLIT = 2;
   */
  TIME_SPLIT = 2,

  /**
   * 変動型.
   *
   * @generated from enum value: SPLIT_SUPPLY_FORM_VARIABLE = 3;
   */
  VARIABLE = 3,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyForm.
 */
export const SplitSupplyFormSchema: GenEnum<SplitSupplyForm> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_contract_model, 0);

/**
 * SplitSupplySelfRole mirrors internalapi.v1.SplitSupplySelfRole 1:1.
 *
 * @generated from enum bffuser.v1.SplitSupplySelfRole
 */
export enum SplitSupplySelfRole {
  /**
   * @generated from enum value: SPLIT_SUPPLY_SELF_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 負荷追随分供給者.
   *
   * @generated from enum value: SPLIT_SUPPLY_SELF_ROLE_LOAD_FOLLOWING = 1;
   */
  LOAD_FOLLOWING = 1,

  /**
   * ベース分供給者.
   *
   * @generated from enum value: SPLIT_SUPPLY_SELF_ROLE_BASE = 2;
   */
  BASE = 2,
}

/**
 * Describes the enum bffuser.v1.SplitSupplySelfRole.
 */
export const SplitSupplySelfRoleSchema: GenEnum<SplitSupplySelfRole> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_contract_model, 1);

/**
 * SplitSupplyNoticeBy mirrors internalapi.v1.SplitSupplyNoticeBy 1:1.
 *
 * @generated from enum bffuser.v1.SplitSupplyNoticeBy
 */
export enum SplitSupplyNoticeBy {
  /**
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * ベース分供給者. 変動型以外は保存時にこの値へ正規化される.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_BY_BASE = 1;
   */
  BASE = 1,

  /**
   * 負荷追随分供給者.
   *
   * @generated from enum value: SPLIT_SUPPLY_NOTICE_BY_LOAD_FOLLOWING = 2;
   */
  LOAD_FOLLOWING = 2,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyNoticeBy.
 */
export const SplitSupplyNoticeBySchema: GenEnum<SplitSupplyNoticeBy> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_contract_model, 2);

/**
 * SplitSupplyDayType mirrors internalapi.v1.SplitSupplyDayType 1:1.
 *
 * @generated from enum bffuser.v1.SplitSupplyDayType
 */
export enum SplitSupplyDayType {
  /**
   * @generated from enum value: SPLIT_SUPPLY_DAY_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SPLIT_SUPPLY_DAY_TYPE_WEEKDAY = 1;
   */
  WEEKDAY = 1,

  /**
   * @generated from enum value: SPLIT_SUPPLY_DAY_TYPE_SATURDAY = 2;
   */
  SATURDAY = 2,

  /**
   * @generated from enum value: SPLIT_SUPPLY_DAY_TYPE_SUNDAY = 3;
   */
  SUNDAY = 3,

  /**
   * @generated from enum value: SPLIT_SUPPLY_DAY_TYPE_HOLIDAY = 4;
   */
  HOLIDAY = 4,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyDayType.
 */
export const SplitSupplyDayTypeSchema: GenEnum<SplitSupplyDayType> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_contract_model, 3);

/**
 * SplitSupplyContractErrorReason mirrors
 * internalapi.v1.SplitSupplyContractErrorReason 1:1. Attached to the Connect
 * error of a rejected Create / UpdateSplitSupplyContract request.
 *
 * @generated from enum bffuser.v1.SplitSupplyContractErrorReason
 */
export enum SplitSupplyContractErrorReason {
  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_SUPPLY_POINT_REQUIRED = 1;
   */
  SUPPLY_POINT_REQUIRED = 1,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_SUPPLY_POINT_NOT_ELIGIBLE = 2;
   */
  SUPPLY_POINT_NOT_ELIGIBLE = 2,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_LOAD_FOLLOWING_SUPPLIER_REQUIRED = 3;
   */
  LOAD_FOLLOWING_SUPPLIER_REQUIRED = 3,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_BASE_SUPPLIER_REQUIRED = 4;
   */
  BASE_SUPPLIER_REQUIRED = 4,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_SELF_ROLE_UNDETERMINED = 5;
   */
  SELF_ROLE_UNDETERMINED = 5,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_SUPPLY_FORM_REQUIRED = 6;
   */
  SUPPLY_FORM_REQUIRED = 6,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_OWN_SLOT_INVALID = 7;
   */
  OWN_SLOT_INVALID = 7,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_SUPPLY_POINT_DUPLICATED = 8;
   */
  SUPPLY_POINT_DUPLICATED = 8,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_PRIORITY_OUT_OF_RANGE = 9;
   */
  PRIORITY_OUT_OF_RANGE = 9,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_PARTNER_NOT_ELIGIBLE = 10;
   */
  PARTNER_NOT_ELIGIBLE = 10,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_OWN_SUPPLIER_NOT_ELIGIBLE = 11;
   */
  OWN_SUPPLIER_NOT_ELIGIBLE = 11,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_PATTERN_ORDER_DUPLICATED = 12;
   */
  PATTERN_ORDER_DUPLICATED = 12,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_PATTERN_DAY_TYPES_REQUIRED = 13;
   */
  PATTERN_DAY_TYPES_REQUIRED = 13,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_PATTERN_PERIOD_INVALID = 14;
   */
  PATTERN_PERIOD_INVALID = 14,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_PATTERN_VALUES_INVALID = 15;
   */
  PATTERN_VALUES_INVALID = 15,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_PATTERN_SLOT_RANGE_INVALID = 16;
   */
  PATTERN_SLOT_RANGE_INVALID = 16,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_BASE_CONTRACT_KW_REQUIRED = 17;
   */
  BASE_CONTRACT_KW_REQUIRED = 17,

  /**
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_NOTICE_BY_REQUIRED = 18;
   */
  NOTICE_BY_REQUIRED = 18,

  /**
   * The 負荷追随分 contract identifier 1 is blank (required for every form).
   *
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_LOAD_FOLLOWING_CONTRACT_ID_REQUIRED = 19;
   */
  LOAD_FOLLOWING_CONTRACT_ID_REQUIRED = 19,

  /**
   * The ベース分 contract identifier 1 is blank (required for every form).
   *
   * @generated from enum value: SPLIT_SUPPLY_CONTRACT_ERROR_REASON_BASE_CONTRACT_ID_REQUIRED = 20;
   */
  BASE_CONTRACT_ID_REQUIRED = 20,
}

/**
 * Describes the enum bffuser.v1.SplitSupplyContractErrorReason.
 */
export const SplitSupplyContractErrorReasonSchema: GenEnum<SplitSupplyContractErrorReason> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_split_supply_contract_model, 4);

